/** Situação da obra que muda a representação no Gantt. */
export const OBRA_SITUACAO_CANCELADA = "CANCELADA";

export interface EmbarcacaoDaObra {
  id: string;
  nome: string;
  acronimo?: string | null;
}

export interface ObraResumo {
  id: string;
  codigo: string;
  nome: string;
  situacao: string;
  embarcacao?: EmbarcacaoDaObra | null;
}

export interface LocalResumo {
  id: string;
  codigo: string;
  nome: string;
  cidade?: string;
  uf?: string;
}

/** Status da alocação, calculado pelo core (o front apenas exibe). */
export type StatusAlocacao = "PLANEJADO" | "REALIZADO";

/** Alocação de uma obra em um Local; `inicio`/`fim` em `yyyy-MM-dd`. */
export interface AlocacaoDeObra {
  id: string;
  inicio: string;
  fim: string;
  obra: ObraResumo;
  status: StatusAlocacao | null;
}

export interface LocalComAlocacoes extends LocalResumo {
  alocacoes: AlocacaoDeObra[];
}

/** Conflito que o usuário marcou como tratado (HU 2042): período e alocações batem com ele. */
export interface ConflitoIgnorado {
  id: string;
  localId: string;
  /** `yyyy-MM-dd` */
  conflitoInicio: string;
  conflitoFim: string;
  alocacaoIds: string[];
}

/** Perspectiva Locais, agrupada por Local. */
export interface AlocacoesPorLocal {
  locais: LocalComAlocacoes[];
  semLocal: ObraResumo[];
  conflitosIgnorados: ConflitoIgnorado[];
}

export interface AlocacaoDeLocal {
  id: string;
  inicio: string;
  fim: string;
  local: LocalResumo;
  status: StatusAlocacao | null;
}

export interface ObraComAlocacoes extends ObraResumo {
  alocacoes: AlocacaoDeLocal[];
}

/** Perspectiva Locais, agrupada por Obra. */
export interface AlocacoesPorObra {
  obras: ObraComAlocacoes[];
}

export interface ListAlocacoesParams {
  /** Primeiro dia do mês inicial (`yyyy-MM-dd`). */
  dataInicio: string;
  /** Último dia do mês final (`yyyy-MM-dd`). */
  dataFim: string;
  busca?: string;
  signal?: AbortSignal;
}

export type AlocacoesStatus = "loading" | "success" | "error" | "forbidden";

export interface AlocacoesQueryState<T> {
  status: AlocacoesStatus;
  data: T | null;
  errorMessage: string | null;
}

export type DisponibilidadeLocal = "DISPONIVEL" | "INDISPONIVEL";

/** Local candidato a substituir o do conflito. */
export interface LocalDisponivel {
  id: string;
  codigo: string;
  nome: string;
  cidade: string;
  uf: string;
  disponibilidade: DisponibilidadeLocal;
}

export interface ListLocaisDisponiveisParams {
  busca?: string;
  /** Período da alocação escolhida (`yyyy-MM-dd`). */
  dataInicio: string;
  dataFim: string;
  /** Obra que terá o local trocado: a própria alocação não conta como ocupação. */
  ignorarObraId: string;
  signal?: AbortSignal;
}

export interface RemanejarLocalRequest {
  localSubstitutoId: string;
  justificativa: string;
}

export interface ConflitoRemanejado {
  localId: string;
  inicio: string;
  fim: string;
  alocacaoIds: string[];
}

export interface RemanejarLocalResult {
  alocacao: { id: string; obraId: string; localId: string; inicio: string; fim: string };
  localAnteriorId: string;
  novoConflito: boolean;
  conflitos: ConflitoRemanejado[];
}

export interface IgnorarConflitoRequest {
  localId: string;
  conflitoInicio: string;
  conflitoFim: string;
  alocacaoIds: string[];
  justificativa: string;
}
